import { initSentry } from "./lib/sentry";
import { initPostHog } from "./lib/posthog";

// Initialize Sentry before anything else to catch early errors
initSentry();
initPostHog();

import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

createRoot(document.getElementById("root")!).render(<App />);
